import { getTvObject, tv } from '@costar-ui/cosmos';

var gridListItemTV = getTvObject({
  //extend: focusRing,
  base: ['relative', 'flex', 'justify-start', 'cursor-pointer', 'select-none', 'items-center', 'gap-2', 'px-2', 'py-1.5', 'will-change-transform', 'outline-none', 'border', 'border-transparent'],
  variants: {
    isSelected: {
      "false": '',
      "true": ''
    },
    noCheckboxMode: {
      // noCheckboxMode confuses me :D
      "true": '',
      "false": ''
    },
    isDisabled: {
      "true": ['bg-action-disabled', 'text-on-action-disabled', 'forced-colors:text-[GrayText]', 'cursor-not-allowed']
    }
  },
  compoundVariants: [{
    isSelected: true,
    noCheckboxMode: true,
    className: ['bg-action-selected', 'text-on-action-selected']
  }, {
    isSelected: false,
    noCheckboxMode: true,
    className: ['hover:bg-accent-hover', 'hover:text-on-accent-hover']
  }, {
    isSelected: true,
    noCheckboxMode: false,
    className: ['hover:bg-accent-hover', 'hover:text-on-accent-hover']
  }, {
    isSelected: false,
    noCheckboxMode: false,
    className: ['hover:bg-accent-hover', 'hover:text-on-accent-hover']
  }, {
    isFocused: true,
    className: ['border-focus']
  }, {
    isSelected: true,
    isFocused: true,
    noCheckboxMode: false,
    className: ['hover:bg-accent-hover', 'hover:text-on-accent-hover']
  }]
});
var base = tv(gridListItemTV);
var gridListItemStyles = {
  base: base
};

export { gridListItemStyles };
//# sourceMappingURL=grid-list-item.styles.esm.js.map
